//src/app/services/payments/services/index.tsx
import { Service, Services } from 'app/services/responseTypes';
import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from '../..';

export const ServicesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getServices: builder.query<Service[], void>({
      query: () => `services`,
      providesTags: () => [{ type: 'Services', id: 'LIST' }],
      transformResponse: (res: Services) => res.services,
    }),
    getService: builder.query<Service, number>({
      query: (id) => `services/${id}`,
      transformResponse: (res: { service: Service }) => res.service,
      providesTags: (_result, _error, id) => [
        { type: 'Services', id },
        { type: 'Services', id: 'LIST' },
      ],
    }),
    getPaginatedServices: builder.query<
      IPaginatedRepsonse<Service>,
      IGetQueryParams<{
        search?: string;
        is_bundle?: boolean;
        price_type_id?: number;
      }>
    >({
      query: (params) => `/services/paginated_index${buildQueryParams(params)}`,
      providesTags: () => [{ type: 'Services', id: 'LIST' }],
    }),
    getMinimalServices: builder.query<Service[], void>({
      query: () => `/services/minimal_index`,
      transformResponse: (res: { services: Service[] }) => res.services,
    }),
    createService: builder.mutation<Service, any>({
      query: (service) => ({
        url: `services`,
        method: 'POST',
        body: { service },
      }),
      invalidatesTags: [{ type: 'Services', id: 'LIST' }],
    }),
    updateService: builder.mutation<Service, { id: number; service: any }>({
      query: ({ id, service }) => ({
        url: `services/${id}`,
        method: 'PUT',
        body: { service },
      }),
      invalidatesTags: [{ type: 'Services', id: 'LIST' }],
    }),
    deleteService: builder.mutation<{ status: string }, number>({
      query: (id) => ({
        url: `services/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Services', id: 'LIST' }],
    }),
    // getServices: builder.query<Services, boolean>({
    //     query: (is_bundle: boolean) => `services?filters[is_bundle]=${is_bundle}`,
    //     providesTags: () => [{ type: 'Services', id: 'LIST' }],
    //   }),
    // createCard: builder.mutation<any, void>({
    //   query: () => ({
    //     url: `/cards/create`,
    //     method: 'POST',
    //   }),
    //   invalidatesTags: [{ type: 'Card', id: 'LIST' }],
    // }),
    // deleteCard: builder.mutation({
    //   query: (id: string) => ({
    //     url: `/cards/destroy/${id}`,
    //     method: 'DELETE',
    //   }),
    //   invalidatesTags: [{ type: 'Cards', id: 'LIST' }],
    // }),
    // setDefaultCard: builder.mutation({
    //   query: (id: string) => ({
    //     url: `cards/set_default/${id}`,
    //     method: 'PUT',
    //   }),
    //   invalidatesTags: [{ type: 'Cards', id: 'LIST' }],
    // }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServiceQuery,
  useLazyGetServiceQuery,
  useLazyGetPaginatedServicesQuery,
  useLazyGetMinimalServicesQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
} = ServicesApi;
